import { render, staticRenderFns } from "./WButton.vue?vue&type=template&id=b139d5b8&scoped=true&lang=pug&"
import script from "./WButton.vue?vue&type=script&lang=js&"
export * from "./WButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b139d5b8",
  null
  
)

export default component.exports